export const generatedMenuItems = [
    {
        type: 'group',
        name: 'administration-menu-item',
        label: 'Administrace',
        parent: null,
        routes: [],
    },
    {
        type: 'group',
        name: 'core-menu-item',
        label: 'Core',
        parent: 'administration-menu-item',
        routes: [],
    },
    {
        type: 'item',
        name: 'core-setting-menu-item',
        label: 'Settings',
        parent: 'core-menu-item',
        routes: ['default-core-setting-browser', 'default-core-setting-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'core-timezone-menu-item',
        label: 'Time Zones',
        parent: 'core-menu-item',
        routes: ['default-core-timezone-browser', 'default-core-timezone-editor'],
        privileges: [["adminSystem"]],
    },
    {
        type: 'item',
        name: 'core-locale-menu-item',
        label: 'Locales',
        parent: 'core-menu-item',
        routes: ['default-core-locale-browser', 'default-core-locale-editor'],
        privileges: [["adminSystem"]],
    },
    {
        type: 'item',
        name: 'core-user-menu-item',
        label: 'Users',
        parent: 'core-menu-item',
        routes: ['default-core-user-browser', 'default-core-user-editor'],
        privileges: [["adminUsers"],["manageUsers"]],
    },
    {
        type: 'item',
        name: 'core-privilege-menu-item',
        label: 'Privileges',
        parent: 'core-menu-item',
        routes: ['default-core-privilege-browser', 'default-core-privilege-editor'],
        privileges: [["adminUsers"]],
    },
    {
        type: 'item',
        name: 'core-role-menu-item',
        label: 'Roles',
        parent: 'core-menu-item',
        routes: ['default-core-role-browser', 'default-core-role-editor'],
        privileges: [["adminUsers"]],
    },
    {
        type: 'item',
        name: 'core-roleprivilege-menu-item',
        label: 'Role Privileges',
        parent: 'core-menu-item',
        routes: ['default-core-roleprivilege-browser', 'default-core-roleprivilege-editor'],
        privileges: [["adminUsers"]],
    },
    {
        type: 'item',
        name: 'core-userrole-menu-item',
        label: 'User Roles',
        parent: 'core-menu-item',
        routes: ['default-core-userrole-browser', 'default-core-userrole-editor'],
        privileges: [["adminUsers"]],
    },
    {
        type: 'item',
        name: 'core-permission-menu-item',
        label: 'Privileges',
        parent: 'core-menu-item',
        routes: ['default-core-permission-browser', 'default-core-permission-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'core-foldertype-menu-item',
        label: 'Folder Types',
        parent: 'core-menu-item',
        routes: ['default-core-foldertype-browser', 'default-core-foldertype-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'core-folder-menu-item',
        label: 'Folders',
        parent: 'core-menu-item',
        routes: ['default-core-folder-browser', 'default-core-folder-editor'],
        privileges: [["adminFileStorage"],["useFileStorage"]],
    },
    {
        type: 'item',
        name: 'core-folderpermission-menu-item',
        label: 'Folder Permissions',
        parent: 'core-menu-item',
        routes: ['default-core-folderpermission-browser', 'default-core-folderpermission-editor'],
        privileges: [["adminFileStorage"],["useFileStorage"]],
    },
    {
        type: 'item',
        name: 'core-filetype-menu-item',
        label: 'File Types',
        parent: 'core-menu-item',
        routes: ['default-core-filetype-browser', 'default-core-filetype-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'core-file-menu-item',
        label: 'Soubory',
        parent: 'core-menu-item',
        routes: ['default-core-file-browser', 'default-core-file-editor'],
        privileges: [["adminFileStorage"],["useFileStorage"]],
    },
    {
        type: 'item',
        name: 'core-workflow-menu-item',
        label: 'Workflow',
        parent: 'core-menu-item',
        routes: ['default-core-workflow-browser', 'default-core-workflow-editor'],
        privileges: [["adminWorkflow"]],
    },
    {
        type: 'item',
        name: 'core-workflowstatus-menu-item',
        label: 'Workflow States',
        parent: 'core-menu-item',
        routes: ['default-core-workflowstatus-browser', 'default-core-workflowstatus-editor'],
        privileges: [["adminWorkflow"]],
    },
    {
        type: 'item',
        name: 'core-workflowtransition-menu-item',
        label: 'Workflow Transitions',
        parent: 'core-menu-item',
        routes: ['default-core-workflowtransition-browser', 'default-core-workflowtransition-editor'],
        privileges: [["adminWorkflow"]],
    },
    {
        type: 'item',
        name: 'core-workflowtransitionprivilege-menu-item',
        label: 'Workflow Transition Privileges',
        parent: 'core-menu-item',
        routes: ['default-core-workflowtransitionprivilege-browser', 'default-core-workflowtransitionprivilege-editor'],
        privileges: [["adminWorkflow"]],
    },
    {
        type: 'group',
        name: 'measurements-menu-item',
        label: 'Measurements',
        parent: 'administration-menu-item',
        routes: [],
    },
    {
        type: 'item',
        name: 'measurements-quantity-menu-item',
        label: 'Measurement Quantities',
        parent: 'measurements-menu-item',
        routes: ['default-measurements-quantity-browser', 'default-measurements-quantity-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'measurements-unit-menu-item',
        label: 'Measurement Units',
        parent: 'measurements-menu-item',
        routes: ['default-measurements-unit-browser', 'default-measurements-unit-editor'],
        privileges: null,
    },
    {
        type: 'group',
        name: 'projects-menu-item',
        label: 'Projects',
        parent: 'administration-menu-item',
        routes: [],
    },
    {
        type: 'item',
        name: 'projects-projecttype-menu-item',
        label: 'Project Types',
        parent: 'projects-menu-item',
        routes: ['default-projects-projecttype-browser', 'default-projects-projecttype-editor'],
        privileges: [["adminProjects"]],
    },
    {
        type: 'item',
        name: 'projects-project-menu-item',
        label: 'Projects',
        parent: 'projects-menu-item',
        routes: ['default-projects-project-browser', 'default-projects-project-editor'],
        privileges: [["adminProjects"],["manageProjects"]],
    },
    {
        type: 'item',
        name: 'projects-projectstagetype-menu-item',
        label: 'Project Stage Types',
        parent: 'projects-menu-item',
        routes: ['default-projects-projectstagetype-browser', 'default-projects-projectstagetype-editor'],
        privileges: [["adminProjects"]],
    },
    {
        type: 'item',
        name: 'projects-workspace-menu-item',
        label: 'Workspaces',
        parent: 'projects-menu-item',
        routes: ['default-projects-workspace-browser', 'default-projects-workspace-editor'],
        privileges: [["adminWorkspace"],["manageWorkspace"]],
    },
    {
        type: 'item',
        name: 'projects-workspacerole-menu-item',
        label: 'Workspaces',
        parent: 'projects-menu-item',
        routes: ['default-projects-workspacerole-browser', 'default-projects-workspacerole-editor'],
        privileges: [["adminWorkspace"],["manageWorkspace"]],
    },
    {
        type: 'item',
        name: 'projects-workspaceproject-menu-item',
        label: 'Workspace Projects',
        parent: 'projects-menu-item',
        routes: ['default-projects-workspaceproject-browser', 'default-projects-workspaceproject-editor'],
        privileges: [["adminWorkspace"],["manageWorkspace"]],
    },
    {
        type: 'group',
        name: 'standards-menu-item',
        label: 'Standards',
        parent: 'administration-menu-item',
        routes: [],
    },
    {
        type: 'item',
        name: 'standards-codestandarddocumenttype-menu-item',
        label: 'Cds Types',
        parent: 'standards-menu-item',
        routes: ['default-standards-codestandarddocumenttype-browser', 'default-standards-codestandarddocumenttype-editor'],
        privileges: [["adminStandards"]],
    },
    {
        type: 'item',
        name: 'standards-codestandarddocument-menu-item',
        label: 'Code Standard Documents',
        parent: 'standards-menu-item',
        routes: ['default-standards-codestandarddocument-browser', 'default-standards-codestandarddocument-editor'],
        privileges: [["adminStandards"]],
    },
    {
        type: 'group',
        name: 'sites-menu-item',
        label: 'Sites',
        parent: 'administration-menu-item',
        routes: [],
    },
    {
        type: 'item',
        name: 'sites-constructionmethod-menu-item',
        label: 'Construction methods',
        parent: 'sites-menu-item',
        routes: ['default-sites-constructionmethod-browser', 'default-sites-constructionmethod-editor'],
        privileges: [["adminSites"]],
    },
    {
        type: 'item',
        name: 'sites-sitetype-menu-item',
        label: 'Site Types',
        parent: 'sites-menu-item',
        routes: ['default-sites-sitetype-browser', 'default-sites-sitetype-editor'],
        privileges: [["adminSites"]],
    },
    {
        type: 'item',
        name: 'sites-site-menu-item',
        label: 'Sites',
        parent: 'sites-menu-item',
        routes: ['default-sites-site-browser', 'default-sites-site-editor'],
        privileges: [["adminSites"]],
    },
    {
        type: 'item',
        name: 'sites-locationtype-menu-item',
        label: 'Location Types',
        parent: 'sites-menu-item',
        routes: ['default-sites-locationtype-browser', 'default-sites-locationtype-editor'],
        privileges: [["adminSites"]],
    },
    {
        type: 'item',
        name: 'sites-location-menu-item',
        label: 'Locations (Objects)',
        parent: 'sites-menu-item',
        routes: ['default-sites-location-browser', 'default-sites-location-editor'],
        privileges: [["adminSites"]],
    },
    {
        type: 'group',
        name: 'model-sections-menu-item',
        label: 'ModelSections',
        parent: 'administration-menu-item',
        routes: [],
    },
    {
        type: 'item',
        name: 'model-sections-storedmodelsection-menu-item',
        label: 'Stored Model Sections',
        parent: 'model-sections-menu-item',
        routes: ['default-model-sections-storedmodelsection-browser', 'default-model-sections-storedmodelsection-editor'],
        privileges: [["adminGeotechData"],["manageGeotechData"]],
    },
    {
        type: 'item',
        name: 'model-sections-modelsection-menu-item',
        label: 'Model Sections',
        parent: 'model-sections-menu-item',
        routes: ['default-model-sections-modelsection-browser', 'default-model-sections-modelsection-editor'],
        privileges: [["adminGeotechData"],["manageGeotechData"]],
    },
    {
        type: 'item',
        name: 'model-sections-modelinterval-menu-item',
        label: 'Model Intervals',
        parent: 'model-sections-menu-item',
        routes: ['default-model-sections-modelinterval-browser', 'default-model-sections-modelinterval-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'model-sections-geoboundarytype-menu-item',
        label: 'Boundary Types',
        parent: 'model-sections-menu-item',
        routes: ['default-model-sections-geoboundarytype-browser', 'default-model-sections-geoboundarytype-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'model-sections-geoboundary-menu-item',
        label: 'Section Boundaries',
        parent: 'model-sections-menu-item',
        routes: ['default-model-sections-geoboundary-browser', 'default-model-sections-geoboundary-editor'],
        privileges: [["adminGeotechData"],["manageGeotechData"]],
    },
    {
        type: 'item',
        name: 'model-sections-geoloadtype-menu-item',
        label: 'Load Types',
        parent: 'model-sections-menu-item',
        routes: ['default-model-sections-geoloadtype-browser', 'default-model-sections-geoloadtype-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'model-sections-geoloaddirectiontype-menu-item',
        label: 'Load Direction Types',
        parent: 'model-sections-menu-item',
        routes: ['default-model-sections-geoloaddirectiontype-browser', 'default-model-sections-geoloaddirectiontype-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'model-sections-geoload-menu-item',
        label: 'Loads',
        parent: 'model-sections-menu-item',
        routes: ['default-model-sections-geoload-browser', 'default-model-sections-geoload-editor'],
        privileges: [["adminGeotechData"],["manageGeotechData"]],
    },
    {
        type: 'item',
        name: 'model-sections-geoobjectkind-menu-item',
        label: 'Object Kinds',
        parent: 'model-sections-menu-item',
        routes: ['default-model-sections-geoobjectkind-browser', 'default-model-sections-geoobjectkind-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'model-sections-geoobjecttype-menu-item',
        label: 'Object Types',
        parent: 'model-sections-menu-item',
        routes: ['default-model-sections-geoobjecttype-browser', 'default-model-sections-geoobjecttype-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'model-sections-geoobject-menu-item',
        label: 'Objects',
        parent: 'model-sections-menu-item',
        routes: ['default-model-sections-geoobject-browser', 'default-model-sections-geoobject-editor'],
        privileges: [["adminGeotechData"],["manageGeotechData"]],
    },
    {
        type: 'item',
        name: 'model-sections-geoobjecttbm-menu-item',
        label: 'Object Tbms',
        parent: 'model-sections-menu-item',
        routes: ['default-model-sections-geoobjecttbm-browser', 'default-model-sections-geoobjecttbm-editor'],
        privileges: [["adminGeotechData"],["manageGeotechData"]],
    },
    {
        type: 'item',
        name: 'model-sections-geoobjecttbmboundary-menu-item',
        label: 'Tbm Levels',
        parent: 'model-sections-menu-item',
        routes: ['default-model-sections-geoobjecttbmboundary-browser', 'default-model-sections-geoobjecttbmboundary-editor'],
        privileges: [["adminGeotechData"],["manageGeotechData"]],
    },
    {
        type: 'item',
        name: 'model-sections-geoobjecttbmsensor-menu-item',
        label: 'Tbm Face Pressure Sensors',
        parent: 'model-sections-menu-item',
        routes: ['default-model-sections-geoobjecttbmsensor-browser', 'default-model-sections-geoobjecttbmsensor-editor'],
        privileges: [["adminGeotechData"],["manageGeotechData"]],
    },
    {
        type: 'group',
        name: 'geo-sections-menu-item',
        label: 'GeoSections',
        parent: 'administration-menu-item',
        routes: [],
    },
    {
        type: 'item',
        name: 'geo-sections-watersurfacestresscalculationmethod-menu-item',
        label: 'Water Surface Stress Calc Methods',
        parent: 'geo-sections-menu-item',
        routes: ['default-geo-sections-watersurfacestresscalculationmethod-browser', 'default-geo-sections-watersurfacestresscalculationmethod-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'geo-sections-piezometricheadcalculationmethod-menu-item',
        label: 'Piezometric Head Calc Methods',
        parent: 'geo-sections-menu-item',
        routes: ['default-geo-sections-piezometricheadcalculationmethod-browser', 'default-geo-sections-piezometricheadcalculationmethod-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'geo-sections-k0calculationmethod-menu-item',
        label: 'K 0 Methods',
        parent: 'geo-sections-menu-item',
        routes: ['default-geo-sections-k0calculationmethod-browser', 'default-geo-sections-k0calculationmethod-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'geo-sections-bulkunitweightgamacalculationmethod-menu-item',
        label: 'Bulk Unit Weight Gama Calc Methods',
        parent: 'geo-sections-menu-item',
        routes: ['default-geo-sections-bulkunitweightgamacalculationmethod-browser', 'default-geo-sections-bulkunitweightgamacalculationmethod-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'geo-sections-minbulkunitweightgamamincalculationmethod-menu-item',
        label: 'Min Bulk Unit Weight Gama Min Calc Methods',
        parent: 'geo-sections-menu-item',
        routes: ['default-geo-sections-minbulkunitweightgamamincalculationmethod-browser', 'default-geo-sections-minbulkunitweightgamamincalculationmethod-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'geo-sections-saturatedunitweightgamasatcalculationmethod-menu-item',
        label: 'Saturated Unit Weight Gama Sat Calc Methods',
        parent: 'geo-sections-menu-item',
        routes: ['default-geo-sections-saturatedunitweightgamasatcalculationmethod-browser', 'default-geo-sections-saturatedunitweightgamasatcalculationmethod-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'geo-sections-submergedunitweightgamasubcalculationmethod-menu-item',
        label: 'Submerged Unit Weight Gama Sub Calc Methods',
        parent: 'geo-sections-menu-item',
        routes: ['default-geo-sections-submergedunitweightgamasubcalculationmethod-browser', 'default-geo-sections-submergedunitweightgamasubcalculationmethod-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'geo-sections-minsubmergedunitweightgamasubmincalculationmethod-menu-item',
        label: 'Min Submerged Unit Weight Gama Sub Min Calc Methods',
        parent: 'geo-sections-menu-item',
        routes: ['default-geo-sections-minsubmergedunitweightgamasubmincalculationmethod-browser', 'default-geo-sections-minsubmergedunitweightgamasubmincalculationmethod-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'geo-sections-dryunitweightgamadcalculationmethod-menu-item',
        label: 'Dry Unit Weight Gama D Calc Methods',
        parent: 'geo-sections-menu-item',
        routes: ['default-geo-sections-dryunitweightgamadcalculationmethod-browser', 'default-geo-sections-dryunitweightgamadcalculationmethod-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'geo-sections-unitweightofsolidsgamascalculationmethod-menu-item',
        label: 'Unit Weight Of Solids Gama S Calc Methods',
        parent: 'geo-sections-menu-item',
        routes: ['default-geo-sections-unitweightofsolidsgamascalculationmethod-browser', 'default-geo-sections-unitweightofsolidsgamascalculationmethod-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'geo-sections-minunitweightofsolidsgamasmincalculationmethod-menu-item',
        label: 'Min Unit Weight Of Solids Gama S Min Calc Methods',
        parent: 'geo-sections-menu-item',
        routes: ['default-geo-sections-minunitweightofsolidsgamasmincalculationmethod-browser', 'default-geo-sections-minunitweightofsolidsgamasmincalculationmethod-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'geo-sections-degreeofsaturationsrcalculationmethod-menu-item',
        label: 'Degree Of Saturation Sr Calc Methods',
        parent: 'geo-sections-menu-item',
        routes: ['default-geo-sections-degreeofsaturationsrcalculationmethod-browser', 'default-geo-sections-degreeofsaturationsrcalculationmethod-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'geo-sections-moisturecontentwcalculationmethod-menu-item',
        label: 'Moisture Content W Calc Methods',
        parent: 'geo-sections-menu-item',
        routes: ['default-geo-sections-moisturecontentwcalculationmethod-browser', 'default-geo-sections-moisturecontentwcalculationmethod-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'geo-sections-plasticityindexipcalculationmethod-menu-item',
        label: 'Plasticity Index Ip Calc Methods',
        parent: 'geo-sections-menu-item',
        routes: ['default-geo-sections-plasticityindexipcalculationmethod-browser', 'default-geo-sections-plasticityindexipcalculationmethod-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'geo-sections-porosityncalculationmethod-menu-item',
        label: 'Porosity N Calc Methods',
        parent: 'geo-sections-menu-item',
        routes: ['default-geo-sections-porosityncalculationmethod-browser', 'default-geo-sections-porosityncalculationmethod-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'geo-sections-voidratioecalculationmethod-menu-item',
        label: 'Void Ratio E Calc Methods',
        parent: 'geo-sections-menu-item',
        routes: ['default-geo-sections-voidratioecalculationmethod-browser', 'default-geo-sections-voidratioecalculationmethod-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'geo-sections-soilunitweightgamacalculationmethod-menu-item',
        label: 'Soil Unit Weight Gama Calc Methods',
        parent: 'geo-sections-menu-item',
        routes: ['default-geo-sections-soilunitweightgamacalculationmethod-browser', 'default-geo-sections-soilunitweightgamacalculationmethod-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'geo-sections-geomasstype-menu-item',
        label: 'Mass Types',
        parent: 'geo-sections-menu-item',
        routes: ['default-geo-sections-geomasstype-browser', 'default-geo-sections-geomasstype-editor'],
        privileges: [["adminSystem"]],
    },
    {
        type: 'item',
        name: 'geo-sections-consistencytype-menu-item',
        label: 'Consistency Types',
        parent: 'geo-sections-menu-item',
        routes: ['default-geo-sections-consistencytype-browser', 'default-geo-sections-consistencytype-editor'],
        privileges: [["adminSystem"]],
    },
    {
        type: 'item',
        name: 'geo-sections-relativedensitytype-menu-item',
        label: 'Relative Density Types',
        parent: 'geo-sections-menu-item',
        routes: ['default-geo-sections-relativedensitytype-browser', 'default-geo-sections-relativedensitytype-editor'],
        privileges: [["adminSystem"]],
    },
    {
        type: 'item',
        name: 'geo-sections-ucstype-menu-item',
        label: 'Ucs Types',
        parent: 'geo-sections-menu-item',
        routes: ['default-geo-sections-ucstype-browser', 'default-geo-sections-ucstype-editor'],
        privileges: [["adminSystem"]],
    },
    {
        type: 'item',
        name: 'geo-sections-tunnelorientationtype-menu-item',
        label: 'Tunnel Orientation Types',
        parent: 'geo-sections-menu-item',
        routes: ['default-geo-sections-tunnelorientationtype-browser', 'default-geo-sections-tunnelorientationtype-editor'],
        privileges: [["adminSystem"]],
    },
    {
        type: 'item',
        name: 'geo-sections-geosection-menu-item',
        label: 'Geo Sections',
        parent: 'geo-sections-menu-item',
        routes: ['default-geo-sections-geosection-browser', 'default-geo-sections-geosection-editor'],
        privileges: [["adminGeotechData"],["manageGeotechData"]],
    },
    {
        type: 'item',
        name: 'geo-sections-geoparams-menu-item',
        label: 'Geo Params',
        parent: 'geo-sections-menu-item',
        routes: ['default-geo-sections-geoparams-browser', 'default-geo-sections-geoparams-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'geo-sections-geotype-menu-item',
        label: 'Geological Types',
        parent: 'geo-sections-menu-item',
        routes: ['default-geo-sections-geotype-browser', 'default-geo-sections-geotype-editor'],
        privileges: [["adminGeotechData"],["manageGeotechData"]],
    },
    {
        type: 'item',
        name: 'geo-sections-geolayer-menu-item',
        label: 'Geological Layers',
        parent: 'geo-sections-menu-item',
        routes: ['default-geo-sections-geolayer-browser', 'default-geo-sections-geolayer-editor'],
        privileges: [["adminGeotechData"],["manageGeotechData"]],
    },
    {
        type: 'item',
        name: 'geo-sections-waterbodytype-menu-item',
        label: 'Water Body Types',
        parent: 'geo-sections-menu-item',
        routes: ['default-geo-sections-waterbodytype-browser', 'default-geo-sections-waterbodytype-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'geo-sections-waterbody-menu-item',
        label: 'Water Bodies',
        parent: 'geo-sections-menu-item',
        routes: ['default-geo-sections-waterbody-browser', 'default-geo-sections-waterbody-editor'],
        privileges: [["adminGeotechData"],["manageGeotechData"]],
    },
    {
        type: 'group',
        name: 'earth-pressures-menu-item',
        label: 'EarthPressures',
        parent: 'administration-menu-item',
        routes: [],
    },
    {
        type: 'item',
        name: 'earth-pressures-earthpressurescalculation-menu-item',
        label: 'Ps Calculations',
        parent: 'earth-pressures-menu-item',
        routes: ['default-earth-pressures-earthpressurescalculation-browser', 'default-earth-pressures-earthpressurescalculation-editor'],
        privileges: [["adminGeotechData"],["manageGeotechData"]],
    },
    {
        type: 'item',
        name: 'earth-pressures-earthpressuresmodelinterval-menu-item',
        label: 'Ps Model Intervals',
        parent: 'earth-pressures-menu-item',
        routes: ['default-earth-pressures-earthpressuresmodelinterval-browser', 'default-earth-pressures-earthpressuresmodelinterval-editor'],
        privileges: [["adminSystem"]],
    },
    {
        type: 'item',
        name: 'earth-pressures-earthpressuresdata-menu-item',
        label: 'Primary Stress Results',
        parent: 'earth-pressures-menu-item',
        routes: ['default-earth-pressures-earthpressuresdata-browser', 'default-earth-pressures-earthpressuresdata-editor'],
        privileges: null,
    },
    {
        type: 'group',
        name: 'face-pressures-menu-item',
        label: 'FacePressures',
        parent: 'administration-menu-item',
        routes: [],
    },
    {
        type: 'item',
        name: 'face-pressures-kacalculationmethod-menu-item',
        label: 'Ka Methods',
        parent: 'face-pressures-menu-item',
        routes: ['default-face-pressures-kacalculationmethod-browser', 'default-face-pressures-kacalculationmethod-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'face-pressures-k1calculationmethod-menu-item',
        label: 'K 1 Methods',
        parent: 'face-pressures-menu-item',
        routes: ['default-face-pressures-k1calculationmethod-browser', 'default-face-pressures-k1calculationmethod-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'face-pressures-k2calculationmethod-menu-item',
        label: 'K 2 Methods',
        parent: 'face-pressures-menu-item',
        routes: ['default-face-pressures-k2calculationmethod-browser', 'default-face-pressures-k2calculationmethod-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'face-pressures-trcalculationmethod-menu-item',
        label: 'Tr Methods',
        parent: 'face-pressures-menu-item',
        routes: ['default-face-pressures-trcalculationmethod-browser', 'default-face-pressures-trcalculationmethod-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'face-pressures-facepressurescalculation-menu-item',
        label: 'J S Calculations',
        parent: 'face-pressures-menu-item',
        routes: ['default-face-pressures-facepressurescalculation-browser', 'default-face-pressures-facepressurescalculation-editor'],
        privileges: [["adminGeotechData"],["manageGeotechData"]],
    },
    {
        type: 'item',
        name: 'face-pressures-facepressuresmodelinterval-menu-item',
        label: 'J S Model Intervals',
        parent: 'face-pressures-menu-item',
        routes: ['default-face-pressures-facepressuresmodelinterval-browser', 'default-face-pressures-facepressuresmodelinterval-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'face-pressures-facepressuresgeotechdata-menu-item',
        label: 'J S Results',
        parent: 'face-pressures-menu-item',
        routes: ['default-face-pressures-facepressuresgeotechdata-browser', 'default-face-pressures-facepressuresgeotechdata-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'face-pressures-facepressuresforcesdata-menu-item',
        label: 'J S Eremax Results',
        parent: 'face-pressures-menu-item',
        routes: ['default-face-pressures-facepressuresforcesdata-browser', 'default-face-pressures-facepressuresforcesdata-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'face-pressures-facepressuresforcesatangle-menu-item',
        label: 'J S Zeta Results',
        parent: 'face-pressures-menu-item',
        routes: ['default-face-pressures-facepressuresforcesatangle-browser', 'default-face-pressures-facepressuresforcesatangle-editor'],
        privileges: null,
    },
    {
        type: 'item',
        name: 'face-pressures-facepressurespressuresatlevel-menu-item',
        label: 'J S Pressure Results',
        parent: 'face-pressures-menu-item',
        routes: ['default-face-pressures-facepressurespressuresatlevel-browser', 'default-face-pressures-facepressurespressuresatlevel-editor'],
        privileges: null,
    },
];
